import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { FileStack } from 'lucide-react';
import { DetailTable } from './DetailTable';
import { eur } from './DetailKpis';

const CategoryShare = ({ rows, total, config }) => {
  const navigate = useNavigate();
  const byCat = useMemo(() => {
    const m = {};
    rows.filter(r => !r.possible_duplicate).forEach(r => { m[r.category] = (m[r.category] || 0) + (Number(r.amount) || 0); });
    return Object.entries(m).sort((a, b) => b[1] - a[1]);
  }, [rows]);
  if (!byCat.length) return null;
  return (
    <div className="flex flex-wrap gap-2" data-testid="period-category-share">
      {byCat.map(([cat, amount]) => {
        const cfg = config[cat] || config.otros;
        const Icon = cfg.icon;
        const pct = total > 0 ? Math.round((amount / total) * 100) : 0;
        return (
          <button key={cat} onClick={() => navigate(`/admin/gastos/categoria/${cat}`)} data-testid={`expense-category-row-${cat}`}
            className="inline-flex items-center gap-1.5 pl-2.5 pr-3 py-1.5 rounded-full text-sm border transition-colors hover:bg-gray-50"
            style={{ borderColor: `${cfg.color}55` }}>
            <Icon size={14} style={{ color: cfg.color }} />
            <span className="font-medium text-gray-800">{cfg.label}</span>
            <span className="font-bold" style={{ color: cfg.color }}>{eur(amount)}</span>
            <span className="text-xs text-gray-400">{pct}%</span>
          </button>
        );
      })}
    </div>
  );
};

const HistoryChips = ({ config }) => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid="expense-category-history">
      <span className="text-xs text-gray-500 mr-1">Historial completo por categoría:</span>
      {Object.entries(config).map(([slug, cfg]) => (
        <button key={slug} onClick={() => navigate(`/admin/gastos/categoria/${slug}`)} data-testid={`expense-category-chip-${slug}`}
          className="px-2.5 py-1 rounded-full text-xs font-medium border hover:bg-gray-50" style={{ borderColor: `${cfg.color}55`, color: cfg.color }}>
          {cfg.label}
        </button>
      ))}
    </div>
  );
};

export const PeriodInvoices = ({ rows, periodLabel, config, onChanged, onEdit }) => {
  const total = rows.filter(r => !r.possible_duplicate).reduce((s, r) => s + (Number(r.amount) || 0), 0);
  return (
    <section className="bg-white rounded-xl shadow-sm border overflow-hidden" data-testid="period-invoices">
      <div className="px-4 py-3 border-b bg-gray-50 flex flex-wrap items-center gap-2">
        <FileStack size={18} className="text-gray-700" />
        <h3 className="font-semibold text-gray-900">Facturas {periodLabel}</h3>
        <span className="ml-auto text-sm text-gray-600" data-testid="period-invoices-total">
          {rows.length} factura{rows.length === 1 ? '' : 's'} · <b className="text-gray-900">{eur(total)}</b>
        </span>
      </div>
      <div className="p-3 space-y-3">
        <CategoryShare rows={rows} total={total} config={config} />
        <DetailTable rows={rows} onDeleted={onChanged} onEdit={onEdit} categoryConfig={config} />
        <HistoryChips config={config} />
      </div>
    </section>
  );
};
